import { useMemo } from 'react'
import { useLocation } from 'react-router-dom'
import { config } from '@/routes'
import { Route } from '../types'
import { buildCrumb, getBreadcrumbForPath } from '../utils'

export function useBreadcrumb() {
  const location = useLocation()
  const currentPath = location.pathname

  const routeMap = useMemo(() => {
    const appRoute = config.find((r: { path?: string }) => r.path === '/app')
    const children = appRoute?.children as Route[] | undefined
    return children ? buildCrumb(children, '/app') : {}
  }, [])

  const breadcrumbItems = useMemo(
    () => getBreadcrumbForPath(routeMap, currentPath),
    [routeMap, currentPath]
  )

  return breadcrumbItems
}
